import {
  CommonDropdownField,
  type CommonDropdownFieldProps,
} from '../../../../common-ui/form-fields/CommonDropdownField';
import { getFieldProps } from '../../../../common-ui/form-fields/getFieldProps';
import type {
  UpdateIntermodalBookingFormModel,
  UpdateIntermodalBookingFormModelDropdownKeys,
} from '../../../../services/intermodal/updateIntermodalReducer';
import { hasDropdownValueChanged } from '../../../multiple-create/hooks/useDropdownField';
import { useUpdateIntermodalField } from '../../hooks/useUpdateIntermodalField';

interface UpdateIntermodalDropDownFieldProps<
  Name extends UpdateIntermodalBookingFormModelDropdownKeys,
> extends Omit<
    CommonDropdownFieldProps<UpdateIntermodalBookingFormModel[Name]>,
    'onValueChange' | 'value' | 'trackerAction'
  > {
  name: Name;
}

export function UpdateIntermodalDropdownField<
  Name extends UpdateIntermodalBookingFormModelDropdownKeys,
>({ name, ...props }: UpdateIntermodalDropDownFieldProps<Name>) {
  const fieldProps = useUpdateIntermodalField(name);
  return (
    <CommonDropdownField
      {...props}
      {...getFieldProps(props, fieldProps)}
      changed={hasDropdownValueChanged(fieldProps, props.transformOption)}
    />
  );
}
